module.exports = __webpack_public_path__ + "img/kjjr.f772bac8.png";